export default "__VITE_ASSET__CT7L_$K7__"